export default {"src":"/_next/static/media/image1.fbb9c0d5.svg","height":136,"width":544,"blurWidth":0,"blurHeight":0};